import { FC, ReactNode, SelectHTMLAttributes, useId } from 'react'
import { IconChevronDown, IconOrder } from 'icons'
import classNames from 'classnames'
import styles from './Select.module.scss'

type TInput = SelectHTMLAttributes<HTMLSelectElement>
type TSize = 'small' | 'medium' | 'big'

export type TProps = {
  size?: TSize
  selectElementProps?: Omit<TInput, 'type'>
  children?: ReactNode
}

const Select: FC<TProps> = ({
  size = 'medium',
  selectElementProps,
  children,
}) => {
  const sizeMap = {
    small: {
      iconSize: 20,
      inputClassName: styles.ecSelectSmall,
      iconLeadingClassName: styles.ecSelectLeadingIconSmall,
      iconTrailingClassName: styles.ecSelectTrailingIconSmall,
    },
    medium: {
      iconSize: 24,
      inputClassName: styles.ecSelect,
      iconLeadingClassName: styles.ecSelectLeadingIcon,
      iconTrailingClassName: styles.ecSelectTrailingIcon,
    },
    big: {
      iconSize: 28,
      inputClassName: styles.ecSelectBig,
      iconLeadingClassName: styles.ecSelectLeadingIconBig,
      iconTrailingClassName: styles.ecSelectTrailingIconBig,
    },
  }

  const controlId = selectElementProps?.id
  const elementId = useId()
  const selectClassName = classNames(
    styles.ecSelect,
    sizeMap[size].inputClassName,
  )

  return (
    <div className={styles.ecSelectContainer}>
      <span className={sizeMap[size].iconLeadingClassName}>
        <IconOrder
          color="grey900"
          title="Ícone"
          width={sizeMap[size].iconSize}
          height={sizeMap[size].iconSize}
        />
      </span>
      <select
        {...selectElementProps}
        id={controlId || elementId}
        className={selectClassName}
      >
        {children}
      </select>
      <span className={sizeMap[size].iconTrailingClassName}>
        <IconChevronDown
          color="grey900"
          title="Ícone"
          width={sizeMap[size].iconSize}
          height={sizeMap[size].iconSize}
        />
      </span>
    </div>
  )
}

export default Select
